/* Sticky add-to-cart bar (all breakpoints).

   The bar must appear only once the buy box has been scrolled PAST, never
   before it has been reached. IntersectionObserver alone gets this wrong -
   anything below the fold is also "not intersecting", so the bar would flash
   up the moment the page loads while the buy box is still further down the
   page. Comparing the buy box's bottom against 0 separates "scrolled past"
   from "not scrolled to yet".

   Both an observer and a scroll listener drive the same setter. Horizon can
   scroll an inner .page-wrapper rather than the window, and in some embedded
   or backgrounded contexts the observer is throttled, so the scroll listener
   is the dependable path rather than a fallback.

   THE BAR'S BUTTONS ARE PROXIES. They forward clicks to the real buy-box
   buttons so there is exactly one place that knows how to add to cart, and
   they MIRROR those buttons' label/disabled/state back. Without the mirror
   the bar looked completely dead: the "Adding…" and "✓ Added" states were
   rendering on the real button, which by definition is scrolled off screen
   whenever the bar is showing - so a customer tapping the sticky button saw
   nothing happen at all. */
(function () {
  'use strict';

  function scrollRoot() {
    var w = document.querySelector('.page-wrapper');
    if (w) {
      var oy = getComputedStyle(w).overflowY;
      if (oy === 'auto' || oy === 'scroll') return w;
    }
    return null;
  }

  /* Copy label + disabled + state from the real button onto its proxy, so the
     bar shows the same feedback the buy box would have. */
  function mirror(src, dst) {
    if (!src || !dst) return;
    function sync() {
      if (dst.innerHTML !== src.innerHTML) dst.innerHTML = src.innerHTML;
      dst.disabled = src.disabled;
      if (src.dataset.state) dst.dataset.state = src.dataset.state;
    }
    new MutationObserver(sync).observe(src, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['disabled', 'data-state']
    });
    sync();
  }

  function proxy(from, to) {
    if (!from || !to) return;
    from.addEventListener('click', function () { to.click(); });
    mirror(to, from);
  }

  function init() {
    var bar = document.querySelector('[data-stickbar]');
    var box = document.querySelector('[data-buybox]');
    if (!bar || !box) return;

    proxy(bar.querySelector('[data-stick-atc]'), document.querySelector('[data-atc]'));
    proxy(bar.querySelector('[data-stick-buy]'), document.querySelector('[data-buynow]'));

    var on = null;
    function set(next) {
      if (next === on) return;
      on = next;
      bar.classList.toggle('is-on', next);
      bar.setAttribute('aria-hidden', String(!next));
    }

    function measure() {
      var r = box.getBoundingClientRect();
      /* scrolled past = the whole buy box is above the top of the viewport */
      set(r.bottom <= 0);
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { ticking = false; measure(); });
    }

    var root = scrollRoot();
    (root || window).addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', measure);

    if ('IntersectionObserver' in window) {
      /* fires once as soon as it starts observing, after layout - so no
         synchronous measure() at startup, which forced a layout mid-load */
      new IntersectionObserver(measure, { threshold: 0 }).observe(box);
    } else {
      measure();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
